import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompanyNavigationComponent } from 'app/shared/components/company-navigation/company-navigation.component';
import { CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

/** Resolve a dot-path from a row, or the row itself when no path is given. */
function resolvePath(obj: unknown, path?: string): any {
  if (!path) return obj;
  return path.split('.').reduce<any>((acc, key) => acc?.[key], obj);
}

/**
 * SmartGrid cell renderer that navigates to a company master via
 * {@link CompanyNavigationComponent}. The company is the row itself, or a nested
 * object addressed by `cellRendererParams.dataPath` (e.g. `dataPath: 'company'`).
 */
@Component({
  selector: 'app-company-nav-cell-renderer',
  standalone: true,
  imports: [CommonModule, CompanyNavigationComponent],
  template: `
    @if (company(); as c) {
      <app-company-navigation
        [data]="c"
        displayMode="both"
        [showIcon]="true"
        interactionMode="icon-only"
        [openInNewTab]="true"
      />
    } @else {
      <span class="text-gray-400">—</span>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyNavCellRendererComponent {
  readonly params = input<CellRendererParams<any>>();

  readonly company = computed(() =>
    resolvePath(this.params()?.data, this.params()?.colDef?.cellRendererParams?.dataPath),
  );
}
